/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Button, Collapse, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {CATEGORIAS, SECCIONES, VALORENVIOGRATIS} from "../../Constantes";
import {useLocation, useNavigate} from "react-router";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import IconoTexto from "./Componentes/IconoTexto";
import {LocalOffer, Mail, Search, WhatsApp} from '@mui/icons-material'
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useContext, useEffect, useState} from "react";
import Tarjeta_Categoria_Desplegable from "../Tarjetas/Tarjeta_Categoria_Desplegable";
import {contexApp} from "../../App";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";

const BarraPc = ({negro = false, mostrar=true}) => {
    const cData = useContext(contexApp);
    const navigate = useNavigate()
    const location = useLocation()
    const {Carrito, abrir, productos} = useCarritoLateral()
    const [palabra, setPalabra] = useState('')
    const [open, setOpen] = useState(false);
    const [openColecciones, setOpenColecciones] = useState(false)
    const [colecciones, setColecciones] = useState([])

    const irRuta = (ruta) => {

        if (ruta === SECCIONES[0]) {

            let seccion = obtenerSeccion(location.pathname)
            if (seccion === 'Detalle' || seccion === 'Recibo') {
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente(SECCIONES[0])
                }, 1000)
            } else {
                scrolearAComponente(SECCIONES[0])
            }


        } else {
            navigate(`/${ruta}`)
        }
    }

    const sePresiono = (e) => {

        if (e.key === 'Enter') {
            navigate('/Resultados/palabra/' + palabra)
        }
    }


    useEffect(() => {

        if (cData.colecciones) {
            setColecciones(cData.colecciones)
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{py: 0, backgroundColor: negro ? '#000' : '#00000000'}}

        >

            <Carrito/>

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                sx={{
                    width: '100%',
                    backgroundColor: '#000',
                }}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3, py: 1, display: mostrar ? 'flex' : 'none'}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 3}}>
                        <IconoTexto Icono={Mail} texto={'contacto@amevi.com.co'} url={'mailto:contacto@amevi.com.co'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}}>
                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{color: '#fff', fontWeight: 300, mt: 0.2}}
                        >


                            <Typography sx={{pl: 1, fontSize: 12}}>
                                {`ENVÍO GRATIS  para pedidos iguales o superiores ${formatoMoneda(VALORENVIOGRATIS)}`}
                            </Typography>

                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                        <IconoTexto Icono={WhatsApp} texto={'+57 320 399 5058'} dir={'flex-end'}
                                    url={'https://api.whatsapp.com/send?phone=573203995058&text=Hola%20Amevi!'}/>
                    </Grid>

                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 6, py: 3}}
            >


                <Grid container size={2} sx={{mt: -1}}
                      onClick={() => navigate(`/Home`)}
                >
                    <img src={logo} width={160} height={'auto'} style={{cursor: 'pointer'}}/>
                </Grid>

                <Grid container size={10} sx={{px: 2}}>
                    <Grid
                        container
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={5}
                    >

                        <>
                            <Typography
                                // onClick={() => irRuta()}
                                onMouseEnter={() => setOpen(true)}
                                onMouseLeave={() => setOpen(false)}
                                sx={{
                                    transition: 'all .3s ease-in-out',
                                    color: '#fff',
                                    fontSize: 13,
                                    cursor: 'pointer',

                                    borderBottom: 1,
                                    fontWeight: 600,
                                    borderColor: '#ffffff00',
                                    mt: 1,
                                    '&:hover': {
                                        borderColor: '#fff',
                                    }
                                }}>
                                {'CATEGORIAS'}

                                <Collapse in={open} timeout="auto" unmountOnExit sx={{position: 'absolute', mt: 1}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{
                                            backgroundColor: '#fff',
                                            py: 1,
                                            maxWidth: 150,
                                            borderRadius: 0,
                                            boxShadow: 4,
                                            px: 2
                                        }}
                                    >


                                        {CATEGORIAS.map((it) => {
                                            return (
                                                <Tarjeta_Categoria_Desplegable it={it.nombre}/>
                                            )
                                        })}


                                    </Grid>
                                </Collapse>
                            </Typography>


                        </>


                        <>
                            <Typography
                                //  onClick={() => setOpen()}
                                onMouseEnter={() => setOpenColecciones(true)}
                                onMouseLeave={() => setOpenColecciones(false)}
                                sx={{
                                    transition: 'all .2s ease-in-out',
                                    color: '#fff',
                                    fontSize: 13,
                                    cursor: 'pointer',
                                    borderBottom: 1,
                                    fontWeight: 600,
                                    borderColor: '#ffffff00',
                                    mt: 1,
                                    '&:hover': {
                                        borderColor: '#fff',
                                    }
                                }}>
                                {'COLECCIONES'}

                                <Collapse in={openColecciones} timeout="auto" unmountOnExit
                                          sx={{position: 'absolute', mt: 1}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{
                                            backgroundColor: '#fff',
                                            py: 1,
                                            maxWidth: 150,
                                            borderRadius: 0,
                                            boxShadow: 4,
                                            px: 2
                                        }}
                                    >


                                        {colecciones.map((it) => {
                                            return (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Typography
                                                        onClick={(e) => navigate('/DetalleCol/' + it.id)}
                                                        sx={{
                                                            transition: 'all .3s ease-in-out',
                                                            color: '#000',
                                                            fontSize: 16,
                                                            cursor: 'pointer',
                                                            borderBottom: 1,
                                                            fontWeight: 400,
                                                            borderColor: '#ffffff00',
                                                            mt: 1,
                                                            '&:hover': {
                                                                borderColor: '#000',
                                                            }
                                                        }}
                                                    >{it.nombre}</Typography>
                                                </Grid>
                                            )
                                        })}


                                    </Grid>
                                </Collapse>
                            </Typography>

                        </>

                        <Typography
                            onClick={() => irRuta('Nosotras')}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                color: '#fff',
                                fontSize: 13,
                                cursor: 'pointer',
                                borderBottom: 1,
                                fontWeight: 600,
                                borderColor: '#ffffff00',
                                mt: 1,
                                '&:hover': {
                                    borderColor: '#fff',
                                }
                            }}>
                            {'NOSOTRAS'}
                        </Typography>

                        <Typography
                            onClick={() => navigate('/Todos')}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                color: '#fff',
                                fontSize: 13,
                                cursor: 'pointer',
                                borderBottom: 1,
                                fontWeight: 600,
                                borderColor: '#ffffff00',
                                mt: 1,
                                '&:hover': {
                                    borderColor: '#fff',
                                }
                            }}>
                            TODOS
                        </Typography>

                        <Typography
                            onClick={() => navigate('/Descuentos')}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                color: '#fff',
                                fontSize: 13,
                                cursor: 'pointer',
                                borderBottom: 1,
                                fontWeight: 600,
                                borderColor: '#ffffff00',
                                mt: 1,
                                '&:hover': {
                                    borderColor: '#fff',
                                }
                            }}>

                            <span><LocalOffer sx={{mt: 0, mb: -0.7, pr: 0.7, width: 20, height: 20}}/></span>
                            SALE
                        </Typography>


                        <TextField
                            label={'Búsqueda por producto'}
                            fullWidth={false}
                            size={'small'}
                            variant={'outlined'}
                            color={'action'}
                            focused
                            value={palabra}
                            onChange={e => setPalabra(e.target.value)}
                            onKeyDown={(e) => sePresiono(e)}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Search
                                                onClick={() => navigate('/Resultados/palabra/' + palabra)}
                                                sx={{fill: '#ffffff90', cursor: 'pointer'}}/>
                                        </InputAdornment>
                                    ),
                                    disableUnderline: true,
                                    sx: {color: '#fff'}
                                },
                                inputLabel: {
                                    sx: {marginLeft: -1, color: '#fff'}
                                }
                            }

                            }
                        />


                        <Button
                            onClick={() => abrir()}
                            sx={{
                                backgroundColor: '#ffffff40',
                                border: 1,
                                borderColor: '#fff',
                                backdropFilter: 'blur(2px)',
                                boxShadow: 0,
                                px: 4
                            }}


                        >
                            <Badge badgeContent={productos.length}
                                   color="secondary"
                                   anchorOrigin={{
                                       vertical: 'top',
                                       horizontal: 'left',
                                   }}
                            >
                                Carrito
                            </Badge>

                        </Button>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default BarraPc